import React, { Component } from 'react'
import { connect } from 'react-redux'
import Portal from "../portal"
import {removeToast} from "../../actions/index"
import ToastMsg from './toastmsg'

class ToastContainer extends Component {
    render() {
        if(this.props.toast.length > 0){
            return (
                <Portal>
                    <div className="toast-container">
                    {
                        this.props.toast.map(t =>
                            <ToastMsg {...t} remove={this.props.removeToast} key={`toast-${t.id}`}/>
                        )
                    }
                    </div>
                </Portal>
            )
        } 
        return null;
    }
}

const mapStateToProps = ({toast}) => ({
    toast
})

const mapDispatchToProps =  {
    removeToast
}

const Toast = connect(mapStateToProps, mapDispatchToProps)(ToastContainer);

export default Toast




